import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import GuideArticlePage from "@/pages/article/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/guides/:slug",
    element: <GuideArticlePage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;